import React from 'react';
import Image from 'next/image';
import { makeStyles } from '@material-ui/core/styles';
import { Input, MenuItem, Select } from '@material-ui/core';

import ChevronDownIcon from 'public/icons/chevron-down.svg';
import styles from 'styles/components/agency/Dashboard.module.scss';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    height: 40,
    minWidth: 145,
    maxWidth: 200,
    border: '1px solid rgb(200, 204, 217)',
  },

  icon: {
    width: 10,
    height: 10,
    top: 'calc(70% - 12px)',
    right: 6,
  },

  paper: {
    borderRadius: 10,
    boxShadow: '0 0 30px 0 rgba(0, 0, 0, 0.1)',
  },

  menuList: {
    padding: '12px 10px',
  },

  menuListItem: {
    padding: '5px 5px',
    margin: '3px 0',
    fontFamily: 'Avenir Heavy',
    fontSize: 14,
    color: '#323643',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',

    '&.Mui-selected': {
      borderTopRightRadius: 5,
      borderTopLeftRadius: 5,
      backgroundColor: '#e8fefc',

      '&:hover': {
        backgroundColor: '#e8fefc',
        borderTopRightRadius: 5,
        borderTopLeftRadius: 5,
        color: '#323643',
      },
    },

    '&:hover': {
      backgroundColor: '#e8fefc',
      borderTopRightRadius: 5,
      borderTopLeftRadius: 5,
      color: '#323643',
    },
  },
}));

const MenuProps = {
  PaperProps: {
    style: {
      padding: '12px 10px',
      borderRadius: 10,
      transition:
        'opacity 257ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 171ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      boxShadow: '0 0 30px 0 rgba(0, 0, 0, 0.1)',
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  autoFocus: false,
};

const MultiSelect = ({ menuItems, setSelectedItems, selectedItems, placeholder }) => {
  const classes = useStyles();

  const handleChange = event => setSelectedItems(event.target.value);

  return (
    <div className={styles.multiSelect}>
      <Select
        multiple
        value={selectedItems}
        disableUnderline
        onChange={handleChange}
        className={classes.root}
        defaultValue="Networks"
        MenuProps={MenuProps}
        IconComponent={ChevronDownIcon}
        inputProps={{
          classes: {
            icon: classes.icon,
          },
        }}
        renderValue={selected =>
          menuItems
            .filter(item => selected.includes(item.id))
            .map(item => item.name)
            .join(', ')
        }
        input={<Input style={selectedItems.length > 0 ? { backgroundColor: '#fff' } : {}} />}
      >
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            value={item.id}
            className={classes.menuListItem}
            style={index === menuItems.length - 1 ? { borderBottom: 'none' } : {}}
          >
            {item.active_icon_url && (
              <div style={{ marginRight: 5, height: 20 }}>
                <Image
                  unoptimized
                  src={item.active_icon_url}
                  width={20}
                  height={20}
                  alt={item.name}
                />
              </div>
            )}

            {item.name}
          </MenuItem>
        ))}
      </Select>

      {selectedItems.length === 0 && (
        <div
          style={{
            position: 'absolute',
            height: 40,
            top: 0,
            right: 0,
            left: 0,
            backgroundColor: '#fff',
            zIndex: '-1',
          }}
        >
          <span
            style={{
              position: 'absolute',
              left: 10,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 0,
            }}
          >
            {placeholder ? placeholder : 'Social Network(s)'}
          </span>
        </div>
      )}
    </div>
  );
};

export default MultiSelect;
